export default __webpack_public_path__ + "static/media/product-video.8d457208.svg";